<template>

<div class="vpn-page">

  <HeadNav />

  <main class="loc">

    <MyvpnbookHeroSection

      v-if="page.hero"

      :label="page.hero.label"

      :title="page.hero.title"

      :description="page.hero.description"

      :cta-label="page.heroCta || 'Get Free VPN'"

      :points="page.hero.points"

    />

    <section class="loc__body">

      <div class="loc__inner">

        <DocBlocks :blocks="page.blocks" />

      </div>

    </section>

  </main>

</div>

</template>



<script>

import '@/css/vpn-theme.scss'

import HeadNav from '@/components/HeadNav.vue'

import DocBlocks from '@/components/myvpnbook/DocBlocks.vue'

import MyvpnbookHeroSection from '@/components/myvpnbook/MyvpnbookHeroSection.vue'

import { locationPages } from '@/data/myvpnbookLocations'



export default {

  name: 'LocationPage',

  components: { HeadNav, DocBlocks, MyvpnbookHeroSection },

  computed: {

    page() {

      const key = this.$route.meta.locationKey

      return locationPages[key] || locationPages.us

    },

  },

  mounted() {

    if (typeof document !== 'undefined') document.body.classList.add('vpn-site')

  },

  beforeDestroy() {

    if (typeof document !== 'undefined') document.body.classList.remove('vpn-site')

  },

}

</script>



<style lang="scss" scoped>

.loc__inner {

  width: var(--vpn-content-width);
  max-width: 100%;

  margin: 0 auto;

}



.loc__body {

  padding: 12px 0 64px;

}

</style>
